if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll(
        "select, .variant-picker__field input[type='radio']"
      );
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    getInputForEventTarget(target) {
      return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
    }

    connectedCallback() {
      this.addEventListener("change", (event) => {
        const target = this.getInputForEventTarget(event.target);
        try {
          // correlate selection -> variantChange using a short token
          const selectionToken = `${Date.now()}-${Math.random().toString(36).slice(2,8)}`;
          // determine if this field is likely a "size" option by inspecting
          // the closest field wrapper for common markers
          let isSize = false;
          try {
            const field = target && target.closest && target.closest('.variant-picker__field');
            if (field) {
              if (field.querySelector && field.querySelector('.open-size-chart')) isSize = true;
              const optName = field.dataset && field.dataset.optionName;
              if (optName) {
                const n = String(optName).toLowerCase();
                const sizeKeywords = ['size', '尺寸', '尺码', '尺碼', 'size chart', 'size-chart'];
                if (sizeKeywords.some((k) => n.indexOf(k) !== -1)) isSize = true;
              }
            }
          } catch (e) {
            // ignore
          }

          window.FoxThemeEvents.emit(PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
              selectionToken,
              isSize,
            },
          });
        } catch (e) {
          // fallback to original emit if anything goes wrong
          window.FoxThemeEvents.emit(PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        }
      });
    }
  }

  customElements.define("variant-picker", VariantPicker);
}
